<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { settingService } from "../../../services/settingservice/setting.service";
import i18n from "../../../i18n";
import Stat from "@/components/widgets/stat";

/* eslint-disable no-console */
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Stat,
  },
  data() {
    return {
      title: "Dashboard",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      dashboards: [],
      isLoading: false,
      fullPage: true,
      canCancel: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#ffffff",
      height: 128,
      width: 128,
      timeout: 1000, //ms
      fetchingStats: true,
      earningStatus: true,

      labels: [i18n.t('property.project'), i18n.t('property.text'), i18n.t('booking.text'), i18n.t('menuitems.dashboards.sold'), i18n.t('property.available')],
      icons: ["bx bx-buildings", "bx bx-building", "bx bx-bookmark", "bx bx-dollar-circle", "bx bx-carousel"],
    };
  },
  mounted() {
    document.body.className = 'light-body';
    this.loadingDashboard();
  },

  methods: {

    loadingDashboard: function() {

      settingService.getDashboardList().then(response => {
        if(response.status == 200) {
          this.dashboards = response.data;

          console.log(JSON.stringify(this.dashboards));
        }

      });
    },

    formatCurrency(value) {

      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

    },

    displayFloor(number, display) {
      return number <= 1 ? '' : `: ${number} ${display}`;
    },
    
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('menuitems.dashboards.text')" :add="null" />

    <div class="row" v-for="(item, index) of dashboards" :key="index">
      <div class="col-xl-4">
        <div class="row" >
          <div class="col-md-12">
            <Stat :icon="'bx bx-buildings'" :value2Size="8.5" :title="$t('property.project')" :value="item.is_system == 0 ? 
              `${item.name} (${item.floor} ${$t('project.floor')})` : `${item.name}`"
              :value2="item.is_system == 0 ? `
              ${$t('project.residence')} ${displayFloor(item.floor - item.parking_floor - item.gem_floor - item.pool_floor - item.skybar_floor, $t('project.floor'))} | 
              ${$t('project.parking')} ${displayFloor(item.parking_floor, $t('project.floor'))} | 
              ${$t('project.gem')} ${displayFloor(item.gem_floor, $t('project.floor'))} | 
              ${$t('project.pool')} ${displayFloor(item.pool_floor, $t('project.floor'))} | 
              ${$t('project.skybar')} ${displayFloor(item.skybar_floor, $t('project.floor'))}
              ` : ''" />
          </div>
        </div>
      </div>
      <div class="col-xl-8" v-show="item.is_system == 0">
        <div class="row">
          <div class="col-md-4">
            <Stat :icon="'bx bx-building'" :title="$t('property.text')" :value="item.property" :value2="formatCurrency(item.total)" />
          </div>
          <!-- <div class="col-md-3">
            <Stat :icon="'bx bx-bookmark'" :title="$t('booking.text')" :value="item.booking" />
          </div> -->
          <div class="col-md-4">
            <Stat :icon="'bx bx-dollar-circle'" :title="$t('menuitems.dashboards.sold')" 
                :value="item.sold" 
                :value2="formatCurrency(item.total_sold)"
                :value3="formatCurrency(item.total_sold_bd)" />
          </div>
          <div class="col-md-4">
            <Stat :icon="'bx bx-carousel'" :title="$t('property.available')" :value="item.available" :value2="formatCurrency(item.total_available)" />
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>
